import PageHeader from "../../components/PageHeader";
import { Alert, Button, Form, Spinner } from "react-bootstrap";
import { Rating } from "@lomarengas/design-system";
import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout";
import Page from "../../types/Page";
import { useParams } from "react-router-dom";
import { selectInputErrors } from "../../features/errors/errorsSlice";
import {
  changeStateFeedbackOwnerComment,
  FeedbackOwnerCommentDto,
  getFeedbackDetailsAsync,
  selectFeedbackDetails,
  selectFeedbackDetailsLoadingStatus,
  updateFeedbackAsync,
} from "./FeedBacksSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import Emoji from "../../components/Emoji/Emoji";
import { dateToDateOnlyString } from "../../common/misc";
import { LOADING_STATUS } from "../../common/constants";
import { useAuthUser } from "../../features/auth/authHooks";

const FeedBackDetailsPageType: Page = {
  ActiveTab: "FeedBacks",
  DisplayName: "Palaute",
  DisplayParentName: "Palautteet",
  LinkUrl: "/feedbacks",
  Path: "/feedbacks",
  RouteName: "feedbacks",
};

const FeedBackDetailsPage = () => {
  const dispatch = useAppDispatch();
  const { isOwnerUser } = useAuthUser();
  const params = useParams();
  const inputErrors = useAppSelector(selectInputErrors);
  const feedbackItem = useAppSelector(selectFeedbackDetails);
  const feedbackItemsLoadingStatus = useAppSelector(
    selectFeedbackDetailsLoadingStatus,
  );
  const [submitted, setSubmitted] = useState(false);
  // const [ownerComment, setOwnerComment] = useState("");
  const doInit = () => {
    // searchFilters.feedbackState = feedbackStateSelect'New';
    dispatch(getFeedbackDetailsAsync(params.feedBackId));
  };
  useEffect(() => {
    doInit();
  }, []);

  const renderAnswerInner = (answer) => {
    if (answer.question.type === "RATING") {
      const starValueHalf = answer.numbericValue * 0.5;
      return (
        <>
          <hr className="hr-light my-32" />
          <div key={`${answer.id}${answer.question.questionId}`}>
            <h2 className="h5">{answer.question.text}</h2>
            <div className="small text-gray-600 mb-32">
              (Kysymyksen ID: {answer.question.questionId})
            </div>
            <div className="row g-24 justify-content-between">
              <div className="col-12 col-lg-auto">
                <div className="d-flex align-items-center">
                  <Rating Rating={starValueHalf} />
                  <span className="fw-bold ms-8">{starValueHalf} / 5</span>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }
    if (answer.question.type === "TEXT") {
      return (
        <>
          <hr className="hr-light my-32" />
          <div key={`${answer.id}${answer.question.questionId}`}>
            <h2 className="h5">{answer.question.text}</h2>
            <div className="small text-gray-600 mb-32">
              (Kysymyksen ID: {answer.question.questionId})
            </div>
            <div className="row g-24 justify-content-between">
              <div className="col-12 col-lg-auto">
                <div className="d-flex align-items-center">
                  <span className="d-inline-block py-4 px-16 bg-white bg-opacity-75 shadow-sm rounded">
                    {answer.textValue}
                  </span>
                </div>
                {answer.reply != null && (
                  <>
                    Vastaus
                    <div className="p-24 bg-white bg-opacity-75 rounded shadow-sm mb-24">
                      {answer.reply}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      );
    }
    if (answer.question.type === "SELECTION") {
      return (
        <>
          <hr className="hr-light my-32" />
          <div key={`${answer.id}${answer.question.questionId}`}>
            <h2 className="h5">{answer.question.text}</h2>
            <div className="small text-gray-600 mb-32">
              (Kysymyksen ID: {answer.question.questionId})
            </div>
            <div className="row g-24 justify-content-between">
              <div className="col-12 col-lg-auto">
                <div className="d-flex align-items-center">
                  <span className="fs-4 d-inline-block py-4 px-16 bg-white bg-opacity-75 shadow-sm rounded">
                    {answer.numbericValue == null ? (
                      <Emoji Score={0} />
                    ) : answer.numbericValue == 1 ? (
                      <Emoji Score={4} />
                    ) : (
                      <Emoji Score={1} />
                    )}
                  </span>
                </div>
                {answer.reply != null && (
                  <>
                    Vastaus
                    <div className="p-24 bg-white bg-opacity-75 rounded shadow-sm mb-24">
                      {answer.reply}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      );
    }
    if (answer.question.type === "SCORE") {
      return (
        <>
          <hr className="hr-light my-32" />
          <div key={`${answer.id}${answer.question.questionId}`}>
            <h2 className="h5">{answer.question.text}</h2>
            <div className="small text-gray-600 mb-32">
              (Kysymyksen ID: {answer.question.questionId})
            </div>
            <div className="row g-24 justify-content-between">
              <div className="col-12 col-lg-auto">
                <div className="d-flex align-items-center">
                  <span className="fs-4 d-inline-block py-4 px-16 bg-white bg-opacity-75 shadow-sm rounded">
                    {answer.numbericValue}
                  </span>
                  <Emoji
                    CssClass="ms-16"
                    Score={answer.numbericValue}
                    Size={28}
                  />
                </div>
                {answer.reply != null && (
                  <>
                    Vastaus
                    <div className="p-24 bg-white bg-opacity-75 rounded shadow-sm mb-24">
                      {answer.reply}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      );
    }
    return null;
  };
  const renderAnswer = (answer) => {
    return <>{renderAnswerInner(answer)}</>;
  };
  const handleOwnerCommentTextChange = (
    Event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const ownerCommentChanged = Event.target.value;
    dispatch(
      changeStateFeedbackOwnerComment({
        ownerCommentChanged,
      }),
    );
  };

  const handleOwnerCommentInputChange = (
    Event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const ownerCommentChanged = Event.target.value;
    dispatch(
      changeStateFeedbackOwnerComment({
        ownerCommentChanged,
      }),
    );
  };

  const handleFeedbackOwnerCommentSave = () => {
    let feedbackOwnerCommentDto: FeedbackOwnerCommentDto = {
      id: feedbackItem.id,
      ownerComment: feedbackItem.ownerComment, //feedbackItem.ownerComment
    };

    dispatch(updateFeedbackAsync(feedbackOwnerCommentDto));
    setSubmitted(true);
  };
  if (
    feedbackItem == null ||
    feedbackItemsLoadingStatus != LOADING_STATUS.IDLE
  ) {
    return (
      <div className={FeedBackDetailsPageType.RouteName}>
        <Layout CurrentPage={FeedBackDetailsPageType}>
          <PageHeader
            Title={FeedBackDetailsPageType.DisplayName}
            SubTitle={FeedBackDetailsPageType.DisplayParentName}
          ></PageHeader>
          Ladataan palautetta... <Spinner animation="border" />
        </Layout>
      </div>
    );
  }

  return (
    <div className={FeedBackDetailsPageType.RouteName}>
      <Layout CurrentPage={FeedBackDetailsPageType}>
        <PageHeader
          Title={FeedBackDetailsPageType.DisplayName}
          SubTitle={FeedBackDetailsPageType.DisplayParentName}
        ></PageHeader>

        <h2 className="h5">Kohde:</h2>
        <p className="mb-24">
          {feedbackItem.accommodationNumber} {feedbackItem.accommodationName}
        </p>
        {feedbackItem.answerTime != null && (
          <>
            <h2 className="h5">Palaute annettu:</h2>
            <p className="mb-24">
              {dateToDateOnlyString(new Date(feedbackItem.answerTime))}
            </p>
          </>
        )}
        {feedbackItem.bookingStartTime != null &&
          feedbackItem.bookingEndTime != null && (
            <>
              <h2 className="h5">Varauksen aikaväli:</h2>
              <p className="mb-24">
                {feedbackItem.bookingStartTime}
                {" - "}
                {feedbackItem.bookingEndTime}
              </p>
            </>
          )}

        {feedbackItem.answers !== undefined &&
          feedbackItem.answers
            .filter((answer) => answer.question.type === "RATING")
            .map((answer) => (
              <React.Fragment key={answer.id}>
                {renderAnswer(answer)}
              </React.Fragment>
            ))}
        {feedbackItem.answers !== undefined &&
          feedbackItem.answers
            .filter((answer) => answer.question.questionId === 3343)
            .map((answer) => (
              <React.Fragment key={answer.id}>
                {renderAnswer(answer)}
              </React.Fragment>
            ))}
        {feedbackItem.answers !== undefined &&
          feedbackItem.answers
            .filter((answer) => answer.question.questionId === 3344)
            .map((answer) => (
              <React.Fragment key={answer.id}>
                {renderAnswer(answer)}
              </React.Fragment>
            ))}
        {feedbackItem.answers !== undefined &&
          feedbackItem.answers
            .filter((answer) => answer.question.questionId === 3356)
            .map((answer) => (
              <React.Fragment key={answer.id}>
                {renderAnswer(answer)}
              </React.Fragment>
            ))}
        <hr className="hr-light my-32" />
        <p className="mb-24">
          Alla olevia arvioita ei julkaista netissä. Ne on tarkoitettu kohteen
          omistajalle tiedoksi ja toimenpiteitä varten.
        </p>

        <h3 className="h5 mb-16">Asteikko 0 - 4</h3>
        <div className="d-grid gap-8">
          <span className="d-flex gap-8 align-items-center body-small">
            <span style={{ width: "38px" }}>0 / 4</span>
            <Emoji Score={0} /> En osaa sanoa / ei ollut
          </span>

          <span className="d-flex gap-8 align-items-center body-small">
            <span style={{ width: "38px" }}>1 / 4</span> <Emoji Score={1} />{" "}
            Paljon parantamisen varaa
          </span>

          <span className="d-flex gap-8 align-items-center body-small">
            <span style={{ width: "38px" }}>2 / 4</span> <Emoji Score={2} />{" "}
            Vähän parantamisen varaa
          </span>

          <span className="d-flex gap-8 align-items-center body-small">
            <span style={{ width: "38px" }}>3 / 4</span> <Emoji Score={3} />{" "}
            Asiat ovat melko hyvin
          </span>

          <span className="d-flex gap-8 align-items-center body-small">
            <span style={{ width: "38px" }}>4 / 4</span> <Emoji Score={4} />{" "}
            Asiakas kiittää
          </span>
        </div>
        {feedbackItem.answers !== undefined &&
          feedbackItem.answers
            .filter((answer) => answer.question.ownerQuestion === true)
            .map((answer) => (
              <React.Fragment key={answer.id}>
                {renderAnswer(answer)}
              </React.Fragment>
            ))}
        <hr className="hr-light my-32" />
        {feedbackItem.serviceComment != null && (
          <>
            <Form.Label>Lomarenkaan kommentti</Form.Label>
            <div className="p-24 bg-white bg-opacity-75 rounded shadow-sm mb-24">
              {feedbackItem.serviceComment}
            </div>
          </>
        )}
        <Form.Group>
          <Form.Label>Omistajan kommentit</Form.Label>
          <br />
          <span>
            <i>
              (Tähän kenttään lisätty kommentti toimitetaan Lomarenkaalle, mutta
              sitä ei julkaista netissä näkyvällä palautteella. Lomarengas lisää
              kommentin tarvittaessa netissä näkyvälle palautteelle.)
            </i>
          </span>
          <Form.Control
            as="textarea"
            rows={4}
            id="feedbackProviderCommentInputField"
            name="feedbackProviderCommentInput"
            defaultValue={feedbackItem.ownerComment}
            disabled={!isOwnerUser}
            onChange={(e) => handleOwnerCommentTextChange(e)}
            onInput={(event: React.ChangeEvent<HTMLInputElement>) =>
              handleOwnerCommentInputChange(event)
            }
          />
          {!submitted && (
            <Button
              variant="primary"
              className="mt-24"
              disabled={!isOwnerUser}
              onClick={() => handleFeedbackOwnerCommentSave()}
            >
              Tallenna
            </Button>
          )}
          {submitted && (
            <Alert variant="success" className="mt-24">
              Kommenttinne on tallennettu!
            </Alert>
          )}
        </Form.Group>
      </Layout>
    </div>
  );
};

export default FeedBackDetailsPage;
